import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { DataService } from '../../data.service';

@Component({
  selector: 'app-time-warning',
  templateUrl: './time-warning.component.html',
  styleUrls: ['./time-warning.component.scss']
})
export class TimeWarningComponent implements OnInit {

  constructor(public dataSvc: DataService,
    public translate: TranslateService) { 
      var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }
  }

  ngOnInit() {
  }

  

}
